import { useMemo } from 'react';
import { deriveProgress, LOG_DAYS, type MyProgress } from '../content/progress';
import { useCountedSessions } from './use-marks';
import { todayIso } from './use-today';

/**
 * The Progress tab's log, week and completion rates, derived from the person's sessions in Core
 * and the marks leaders made for them. `logUntil` is the day picked in the log's date selector;
 * the log ends there instead of today.
 */
export function useMyProgress(logUntil?: string) {
  const sessions = useCountedSessions();
  const today = todayIso();
  const data = useMemo(
    (): MyProgress | undefined =>
      sessions.data ? deriveProgress(sessions.data, today, LOG_DAYS, logUntil ?? today) : undefined,
    [sessions.data, today, logUntil],
  );
  return {
    data,
    isLoading: sessions.isLoading,
    error: sessions.error,
    refetch: sessions.refetch,
  };
}
